module.exports = __webpack_public_path__ + "0ea0dfd1d31f205cbdec5019228b408c.MP3";